const fmt = (n) =>
    new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 0 }).format(
        Number(n) || 0
    );

const fmtPercent = (n) =>
    `${new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 4 }).format(
        Number(n) || 0
    )}٪`;

export default function ResultCard({ result }) {
    if (!result) return null;

    const {
        caps,
        total_commission_amount,
        total_commission_percent,
        remaining_margin_amount,
        remaining_margin_percent,
        is_safe,
        warning,
        chain_truncated,
        chain_truncated_warning,
    } = result;

    return (
        <div className="result-card" style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '1rem', textAlign: 'center' }}>
            {/* Chain truncation warning — TOP */}
            {chain_truncated && chain_truncated_warning && (
                <div className="chain-truncated-banner" style={{ background: '#fef3c7', color: '#92400e', padding: '0.5rem', borderRadius: '8px', marginBottom: '0.75rem', textAlign: 'center', fontSize: '0.8rem' }}>
                    <span className="chain-truncated-icon">⚠️</span>
                    <span>{chain_truncated_warning}</span>
                </div>
            )}

            <div className={`status-banner ${is_safe ? 'safe' : 'danger'}`} style={{ background: is_safe ? '#dcfce7' : '#fee2e2', color: is_safe ? '#15803d' : '#b91c1c', padding: '0.5rem', borderRadius: '8px', fontWeight: 'bold', marginBottom: '0.75rem', textAlign: 'center', fontSize: '0.9rem' }}>
                {is_safe ? '✅ وضعیت امن' : '❌ خطر'}
            </div>

            {warning && <div className="warning-banner" style={{ background: '#fffbeb', color: '#b45309', padding: '0.5rem', borderRadius: '8px', marginBottom: '0.75rem', textAlign: 'center', fontSize: '0.8rem' }}>{warning}</div>}

            {/* === [CHANGED] قرارگیری ۴ سقف در یک خط بدون شکستن === */}
            <div className="caps-grid" style={{
                display: 'flex',
                flexWrap: 'nowrap',
                overflowX: 'auto',
                gap: '0.25rem',
                marginBottom: '0.75rem',
                background: '#f8fafc',
                padding: '0.5rem',
                borderRadius: '8px',
            }}>
                <div className="cap-item" style={{ flex: '1 1 0', minWidth: '75px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.65rem', color: '#64748b', whiteSpace: 'nowrap' }}>سقف قانونی</span>
                    <strong style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>{fmtPercent(caps.legal_cap)}</strong>
                </div>
                <div className="cap-item" style={{ flex: '1 1 0', minWidth: '75px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.65rem', color: '#64748b', whiteSpace: 'nowrap' }}>سقف از سود</span>
                    <strong style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>{fmtPercent(caps.safety_cap)}</strong>
                </div>
                <div className="cap-item" style={{ flex: '1 1 0', minWidth: '75px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.65rem', color: '#64748b', whiteSpace: 'nowrap' }}>سقف از سبد</span>
                    <strong style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>{fmtPercent(caps.sales_cap)}</strong>
                </div>
                <div className="cap-item highlight" style={{ flex: '1 1 0', minWidth: '75px', display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#eff6ff', borderRadius: '6px', border: '1px solid #bfdbfe', padding: '0.2rem' }}>
                    <span style={{ fontSize: '0.65rem', color: '#1e40af', fontWeight: 'bold', whiteSpace: 'nowrap' }}>سقف نهایی</span>
                    <strong style={{ color: '#1e3a8a', fontSize: '0.85rem', whiteSpace: 'nowrap' }}>{fmtPercent(caps.final_cap)}</strong>
                </div>
            </div>

            {/* === [CHANGED] قرارگیری ۲ مجموع در یک خط === */}
            <div className="totals-grid" style={{
                display: 'flex',
                flexWrap: 'nowrap',
                overflowX: 'auto',
                gap: '0.25rem',
                marginBottom: '1rem',
                textAlign: 'center'
            }}>
                <div className="total-item" style={{ flex: '1 1 0', display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#f0f9ff', padding: '0.5rem', borderRadius: '6px' }}>
                    <span style={{ fontSize: '0.75rem', color: '#0369a1', whiteSpace: 'nowrap' }}>مجموع پورسانت</span>
                    <strong style={{ fontSize: '0.9rem', color: '#0284c7', whiteSpace: 'nowrap' }}>{fmt(total_commission_amount)} ریال</strong>
                    <small style={{ color: '#64748b', fontSize: '0.65rem' }}>({fmtPercent(total_commission_percent)})</small>
                </div>
                <div className="total-item" style={{ flex: '1 1 0', display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#ecfdf5', padding: '0.5rem', borderRadius: '6px' }}>
                    <span style={{ fontSize: '0.75rem', color: '#047857', whiteSpace: 'nowrap' }}>سود باقی‌مانده</span>
                    <strong style={{ fontSize: '0.9rem', color: '#059669', whiteSpace: 'nowrap' }}>{fmt(remaining_margin_amount)} ریال</strong>
                    <small style={{ color: '#64748b', fontSize: '0.65rem' }}>({fmtPercent(remaining_margin_percent)})</small>
                </div>
            </div>

            <div className="levels-table-wrap">
                <table className="levels-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                    <thead>
                    <tr style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
                        <th style={{ padding: '0.4rem', textAlign: 'center', color: '#374151', fontSize: '0.8rem' }}>سطح</th>
                        <th style={{ padding: '0.4rem', textAlign: 'center', color: '#374151', fontSize: '0.8rem' }}>درصد پورسانت</th>
                        <th style={{ padding: '0.4rem', textAlign: 'center', color: '#374151', fontSize: '0.8rem' }}>مبلغ سود (از این سبد)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {result.levels.map((lvl) => (
                        <tr key={lvl.level} style={{ borderBottom: '1px solid #f1f5f9' }}>
                            <td style={{ padding: '0.4rem', textAlign: 'center', fontWeight: 'bold', fontSize: '0.85rem' }}>{lvl.level}</td>
                            <td style={{ padding: '0.4rem', textAlign: 'center', fontSize: '0.85rem' }}>{fmtPercent(lvl.percent)}</td>
                            <td style={{ padding: '0.4rem', textAlign: 'center', color: '#059669', fontWeight: 'bold', fontSize: '0.85rem' }}>{fmt(lvl.amount)} ریال</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}